export default __webpack_public_path__ + "static/media/LINK.0dabe41c.svg";